import { restHeartClient } from '..'

/**
 * 批量文档删除。
 * @param db
 * @param collection
 * @param filter
 */
export function deleteDocumentBatch(db: string, collection: string, filter: any) {
	if (!filter) {
		throw new Error('批量删除必须指定条件！')
	}
	return restHeartClient.delete(`${db}/${collection}/*`, {
		params: {
			filter,
		},
	})
}
